var $ = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $(doc);
    }
    return doc.querySelector(obj)
  }else{
    return document.querySelector(obj)
  }
}
var $$ = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $(doc);
    }
    return doc.querySelectorAll(obj)
  }else{
    return document.querySelectorAll(obj)
  }
};

function getStyle (obj, attr) { 
  obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle( obj )[attr]; 
}

NodeList.prototype.addEventListener = function(event, fn, useCapture){
  this.forEach(function(element) {
    element.addEventListener(event, fn, useCapture)
  })
} 
NodeList.prototype.show = function (displayType) {
  this.forEach(function(element) {
    element.style.display = displayType ? displayType : 'block';
  });
}
Element.prototype.show = function (displayType) {
  this.style.display = displayType ? displayType : 'block';
}
NodeList.prototype.hide = function () {
  this.forEach(function(element) {
    element.style.display = 'none';
  });
}
Element.prototype.hide = function () {
  this.style.display = 'none';
}

loadFunctionArr = window['loadFunctionArr'] || [];

document.addEventListener('DOMContentLoaded', function() {
    
  loadFunctionArr.forEach(function(fn){
    if(typeof fn == 'function'){
      fn();
    }
  });

  $$('[data-copy]').addEventListener('click', function(){
    var couponVal = this.getAttribute('data-copy');
    var text = this.getAttribute('data-text');
    copyText(couponVal.trim(), text);
    return false
  }); 

}, false);


function copyText(val, msg, okFn) {
  var inputObj = $$('#copyTextInput');
  if(inputObj.length){
    inputObj = inputObj[0];
    inputObj.value = val;
    inputObj.select();
    inputObj.setSelectionRange(0, inputObj.value.length),
        document.execCommand("Copy");
    inputObj.blur();
    var text = msg || "Copied Successfully";
    alert(text ).okBtn(function () {
        okFn && okFn();
    });
  }
}